import React from "react";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import NotificationsIcon from "@material-ui/icons/Notifications";

import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withNews from "../hocs/withNews";

import NotificationMenuItem from "./NotificationMenuItem";

const styles = (theme) => ({
    buttonStyle: {
        padding: "5px 10px 0 10px",
    },
    badgeStyle: {
        backgroundColor: "#E40045",
        color: "#fff",
        top: "-7px",
        right: "-10px",
        minWidth: 20,
        width: "auto",
        height: 21,
        padding: "0 4px 1px",
        borderRadius: "11px",
        border: "1px solid #fff",
        fontSize: "11px",
    },
    menuPaperStyle: {
        backgroundColor: "transparent",
        "&:before": {
            content: '""',
            height: "10px",
            width: "10px",
            display: "block",
            position: "absolute",
            right: "113px",
            top: "2px",
            borderRadius: "2px",
            backgroundColor: "#fff",
            transform: "rotate(45deg)",
        },
    },
    menuListStyle: {
        backgroundColor: "#fff",
        borderRadius: "4px",
        padding: "0 0 12px",
        marginTop: "6px",
    },
    menuItemStyle: {
        padding: 0,
        position: "relative",
        height: "inherit",
        width: "350px",
        maxWidth: "350px",
        backgroundColor: "#fff",
        "&:first-child": {
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
        },
        borderBottom: "1px solid #fff",
    },
    itemUnreadStyle: {
        "&:before": {
            position: "absolute",
            top: 0,
            left: 0,
            right: "5px",
            bottom: 0,
            background: "#E40045",
            width: "6px",
            content: '""',
            display: "block",
            borderBottom: "1px solid #fff",
        },
    },
    itemCtaStyle: {
        padding: 0,
        margin: "12px 16px 0",
        height: 38,
        maxWidth: "350px",
        backgroundColor: "#e40045",
        borderRadius: 4,
        color: "#fff",
        "&:hover": {
            backgroundColor: "#b10036",
        },
        "& span": {
            fontSize: theme.typography.pxToRem(12),
            fontFamily: "Arial, sans-serif",
            lineHeight: "normal",
            fontWeight: "normal",
            textAlign: "center",
            width: "100%",
        },
    },
});

const NotificationBadge = ({ content, badgeStyle, max = 99 }) => {
    const displayValue = content > max ? `${max}+` : content;
    return (
        <Badge badgeContent={displayValue} classes={{ badge: badgeStyle }}>
            <NotificationsIcon nativeColor="#303C49" />
        </Badge>
    );
};

class NotificationsMenu extends React.Component {
    state = {
        anchorEl: null,
    };

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { anchorEl } = this.state;
        const {
            classes: {
                buttonStyle,
                badgeStyle,
                menuPaperStyle,
                menuListStyle,
                menuItemStyle,
                itemUnreadStyle,
                itemCtaStyle,
            },
            history,
            news,
            unreadNewsCount,
            generalTranslations,
        } = this.props;

        return news.length > 0 ? (
            <div>
                <ButtonBase
                    className={buttonStyle}
                    aria-owns={anchorEl ? "settings-menu" : null}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                >
                    {unreadNewsCount > 0 ? (
                        <NotificationBadge content={unreadNewsCount} badgeStyle={badgeStyle} />
                    ) : (
                        <NotificationsIcon nativeColor="#ACB1B6" />
                    )}
                </ButtonBase>
                <Menu
                    classes={{ paper: menuPaperStyle }}
                    id="notifications-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: 140,
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    getContentAnchorEl={null}
                    MenuListProps={{ className: menuListStyle }}
                >
                    {news.map(({ id, headline, text, publicationDate, isUnread }) => (
                        <MenuItem
                            key={id}
                            className={`${menuItemStyle} ${isUnread && itemUnreadStyle}`}
                            onClick={() => {
                                history.push("/news");
                                this.handleClose();
                            }}
                        >
                            <NotificationMenuItem
                                date={publicationDate}
                                headline={headline}
                                text={text}
                                isUnread={isUnread}
                            />
                        </MenuItem>
                    ))}
                    <MenuItem
                        className={itemCtaStyle}
                        onClick={() => {
                            history.push("/news");
                            this.handleClose();
                        }}
                    >
                        <span>{generalTranslations("show-news")}</span>
                    </MenuItem>
                </Menu>
            </div>
        ) : (
            <ButtonBase
                className={buttonStyle}
                aria-owns={anchorEl ? "settings-menu" : null}
                aria-haspopup="true"
                onClick={this.handleClick}
            >
                <NotificationsIcon nativeColor="#ACB1B6" />
            </ButtonBase>
        );
    }
}

const EmptyNotification = () => (
    <ButtonBase style={{ padding: "5px 10px 0 10px" }} aria-haspopup="true" onClick={this.handleClick}>
        <NotificationsIcon nativeColor="#ACB1B6" />
    </ButtonBase>
);

export default compose(
    withRouter,
    withGeneralTranslations,
    withNews(EmptyNotification),
    withStyles(styles)
)(NotificationsMenu);



// WEBPACK FOOTER //
// ./src/components/NotificationsMenu.js